/**
 * author       : zwl
 * createTime   : 2018/8/3 上午9:43
 * description  :
 */
import api from 'util/axios'

export function selectOrderByArea (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/selectOrderByArea/' + params.appId,
    data: params
  })
}

export function finance (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/finance/' + params.appId,
    data: params
  })
}

export function financeByYear (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/financeByYear/' + params.appId,
    data: params
  })
}

export function areaByYear (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/areaByYear/' + params.appId,
    data: params
  })
}

export function areaBySupply (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/areaBySupply/' + params.appId,
    data: params
  })
}

export function areaList (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/areaList/' + params.appId,
    data: params
  })
}

export function financeByUser (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/financeByUser/' + params.appId,
    data: params
  })
}
// 获取年月日销售增长趋势
export function financeByAllDetail (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/financeByAllDetail/' + params.appId,
    data: params
  })
}

export function driverHistory (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/driverHistory/' + params.appId,
    data: params
  })
}

export function driverOrderBySale (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/driverOrderBySale/' + params.appId,
    data: params
  })
}

export function selectAnalysisByArea (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/selectAnalysisByArea/' + params.appId,
    data: params
  })
}

export function selectAnalysisByProvider (params) {
  return api({
    method: 'post',
    url: '/ordersStatistics/analysisByProvider/' + params.appId,
    data: params
  })
}

export function userPercent (appId) {
  return api({
    method: 'get',
    url: '/ordersStatistics/userPercent/' + appId
  })
}
